
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { languageMixin } from "@/mixins/languageMixin";
import MainHeader from "@/components/main-header.vue";
import TimeRange from "../components/time-range.vue";
import Empty from "@/components/empty.vue";
import echarts from "echarts";
import { getCurrentTime } from "@/utils/base";
import {
  PostStatisticsPatient,
  PostStatisticsCeping,
  PostStatisticsTem,
  PostStatisticsResult,
} from "@/request/common";
@Component({
  components: {
    MainHeader,
    TimeRange,
    Empty,
  },
})
export default class Name extends mixins(languageMixin) {
  private newstYear: any = [];
  private cepingTimes: any = [
    "全部时间",
    "最近1年",
    "最近6个月",
    "最近1个月",
    "自定义",
  ];
  private filters: any = {
    cepingYear: "",
    cepingTime: "全部时间",
    startTime: "",
    endTime: "",
  };
  private cepingqushi: any = {};
  private cepingFenbu: any = {};
  private ceping: any = {};
  private ageOptions: any = {};
  private huiyuanOption: any = {};
  private colors: any = [
    "#77A4F1",
    "#FFB025",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
  ];
  private cepingData: any = {};
  private huiyuanData: any = {
    sexData: {},
  };
  private temData: any = {};
  private resultData: any = {};
  private cSource: any = {};
  private cTem: any = {};
  private data: any = {
    月测评趋势图: {
      data: [
        {
          title: "一月",
          value: 8282,
        },
        {
          title: "二月",
          value: 36982,
        },
        {
          title: "三月",
          value: 49361,
        },
        {
          title: "四月",
          value: 47044,
        },
        {
          title: "五月",
          value: 48670,
        },
        {
          title: "六月",
          value: 7922,
        },
        {
          title: "七月",
          value: 56747,
        },
        {
          title: "八月",
          value: 36237,
        },
        {
          title: "九月",
          value: 45862,
        },
        {
          title: "十月",
          value: 62553,
        },
        {
          title: "十一月",
          value: 53686,
        },
        {
          title: "十二月",
          value: 45919,
        },
      ],
      title: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月",
      ],
    },
    各团体测评量分布状况: {
      柱状图: {
        data: [
          {
            hospital_id: "hospital_id_94",
            ratio: 0.7678,
            title: "展会10",
            value: 281,
          },
          {
            hospital_id: "hospital_id_95",
            ratio: 0.0902,
            title: "展会11",
            value: 33,
          },
          {
            hospital_id: "hospital_id_1",
            ratio: 0.0519,
            title: "上海华山医院",
            value: 19,
          },
          {
            hospital_id: "hospital_id_241",
            ratio: 0.0437,
            title: "沪东医院",
            value: 16,
          },
          {
            hospital_id: "hospital_id_85",
            ratio: 0.0383,
            title: "展会1",
            value: 14,
          },
        ],
        title: ["展会10", "展会11", "上海华山医院", "沪东医院", "展会1"],
      },
      饼图: {
        data: [
          {
            ratio: 0.7678,
            title: "展会10",
            value: 281,
          },
          {
            ratio: 0.0902,
            title: "展会11",
            value: 33,
          },
          {
            ratio: 0.0519,
            title: "上海华山医院",
            value: 19,
          },
          {
            ratio: 0.0437,
            title: "沪东医院",
            value: 16,
          },
          {
            ratio: 0.0383,
            title: "展会1",
            value: 14,
          },
        ],
        title: ["展会10", "展会11", "上海华山医院", "沪东医院", "展会1"],
      },
    },
    测评数据: {
      data: [
        {
          ratio: "58.73%",
          title: "舌图数据采集报告",
          value: 619,
        },
        {
          ratio: "9.20%",
          title: "面图数据采集报告",
          value: 97,
        },
        {
          ratio: "5.69%",
          title: "中医体质辨识",
          value: 60,
        },
        {
          ratio: "4.27%",
          title: "老年人体质辨识",
          value: 45,
        },
        {
          ratio: "3.98%",
          title: "四诊合参体质辨识",
          value: 42,
        },
        {
          ratio: "3.32%",
          title: "五态性格问卷测评（简）",
          value: 35,
        },
        {
          ratio: "2.75%",
          title: "中成药辅助辨证决策",
          value: 29,
        },
        {
          ratio: "1.99%",
          title: "备孕女性健康状态测评",
          value: 21,
        },
        {
          ratio: "1.61%",
          title: "产后女性健康状态测评",
          value: 17,
        },
        {
          ratio: "1.52%",
          title: "孕期女性健康状态测评",
          value: 16,
        },
        {
          ratio: "1.23%",
          title: "0-6岁儿童体质辨识",
          value: 13,
        },
        {
          ratio: "1.14%",
          title: "高血压辅助辨证",
          value: 12,
        },
        {
          ratio: "1.04%",
          title: "糖尿病辅助辨证",
          value: 11,
        },
        {
          ratio: "1.04%",
          title: "7-12岁儿童体质辨识",
          value: 11,
        },
        {
          ratio: "1.04%",
          title: "脉图数据采集报告",
          value: 11,
        },
        {
          ratio: "0.66%",
          title: "围绝经期女性健康状态测评",
          value: 7,
        },
        {
          ratio: "0.47%",
          title: "五脏相音健康养生测评",
          value: 5,
        },
        {
          ratio: "0.28%",
          title: "五态性格问卷测评",
          value: 3,
        },
        {
          ratio: "0.00%",
          title: "病例数据报告",
          value: 0,
        },
      ],
      title: [
        "舌图数据采集报告",
        "面图数据采集报告",
        "中医体质辨识",
        "老年人体质辨识",
        "四诊合参体质辨识",
        "五态性格问卷测评（简）",
        "中成药辅助辨证决策",
        "备孕女性健康状态测评",
        "产后女性健康状态测评",
        "孕期女性健康状态测评",
        "0-6岁儿童体质辨识",
        "高血压辅助辨证",
        "糖尿病辅助辨证",
        "7-12岁儿童体质辨识",
        "脉图数据采集报告",
        "围绝经期女性健康状态测评",
        "五脏相音健康养生测评",
        "五态性格问卷测评",
        "病例数据报告",
      ],
    },
    ageData: {
      data: [
        {
          ratio: 0.3093,
          title: "其它",
          value: 90,
        },
        {
          ratio: 0.2749,
          title: "41岁以上",
          value: 80,
        },
        {
          ratio: 0.1031,
          title: "36-40岁",
          value: 30,
        },
        {
          ratio: 0.1031,
          title: "31-35岁",
          value: 30,
        },
        {
          ratio: 0.0412,
          title: "25-30岁",
          value: 12,
        },
        {
          ratio: 0.1649,
          title: "24岁以下",
          value: 48,
        },
      ],
      title: ["其它", "41岁以上", "36-40岁", "31-35岁", "25-30岁", "24岁以下"],
    },
    sexData: {
      男: 0.4467,
      女: 0.2405,
      data: [
        {
          ratio: 0.4467,
          title: "男",
          value: 130,
        },
        {
          ratio: 0.2405,
          title: "女",
          value: 70,
        },
      ],
      title: ["男", "女"],
    },
    会员分布: {
      data: [
        {
          ratio: "25.00%",
          title: "肾精亏虚",
          value: 3,
        },
        {
          ratio: "16.67%",
          title: "肝阳上亢（阳虚型）",
          value: 2,
        },
        {
          ratio: "8.33%",
          title: "肝血不足",
          value: 1,
        },
        {
          ratio: "8.33%",
          title: "肝阳化风",
          value: 1,
        },
        {
          ratio: "8.33%",
          title: "肝阳上亢（阴虚型）",
          value: 1,
        },
        {
          ratio: "8.33%",
          title: "胃火炽盛",
          value: 1,
        },
        {
          ratio: "8.33%",
          title: "痰（湿）热蕴结",
          value: 1,
        },
        {
          ratio: "8.33%",
          title: "阴虚火旺",
          value: 1,
        },
        {
          ratio: "8.33%",
          title: "心阳虚",
          value: 1,
        },
      ],
      title: [
        "肾精亏虚",
        "肝阳上亢（阳虚型）",
        "肝血不足",
        "肝阳化风",
        "肝阳上亢（阴虚型）",
        "胃火炽盛",
        "痰（湿）热蕴结",
        "阴虚火旺",
        "心阳虚",
      ],
    },
  };
  private isHasValue(arr: any) {
    let num = 0;
    arr.forEach((ele: any) => {
      num += ele.value;
    });
    return num;
  }
  private selectSource(item: any) {
    this.cSource = item;
    this.getTemData();
  }
  private selectTem(item: any) {
    this.cTem = item;
    this.getResultData();
  }
  private changeYear(item: any) {
    this.filters.cepingYear = item;
    this.getCepingData();
  }
  private changeTime(item: any) {
    this.filters.cepingTime = item;
    if (item != "自定义") {
      this.getCepingData();
    }
  }
  private timeChange(e: any) {
    this.filters = JSON.parse(JSON.stringify(e));
  }
  /**
   * @description 计算各机构服务量分布的背景
   */
  private calBackground(index: any, item: any, first: any) {
    const max = first.value;
    if (!this.$refs.zongliang as any) {
      return {};
    }
    // 总共40个颜色，除40取余
    const style: any = {};
    style.backgroundColor = this.colors[index % 40];
    if (!style.backgroundColor) {
      style.backgroundColor = "#000000";
    }
    const w =
      (item.value / max) * ((this.$refs.zongliang as any).offsetWidth - 10);
    if (w > 0 && w < 40) {
      style.width = 40 + "px";
    } else {
      style.width = w - 10 + "px";
    }
    return style;
  }
  private getYears() {
    let arr: any = [];
    const year: any = getCurrentTime("yyyy");
    for (var i = 0; i < 5; i++) {
      arr.push(year - i);
    }
    this.newstYear = arr;
    this.filters.cepingYear = arr[0];
  }
  private drawCepingQushi() {
    const data = this.cepingData.by_month_echarts;
    this.cepingqushi = {
      color: ["#FFA400"],
      tooltip: {
        show: true,
        trigger: "item",
      },
      grid: {
        left: "80",
        right: "2%",
        top: "40",
        bottom: "40",
      },
      xAxis: {
        type: "category",
        axisLabel: {
          color: "rgba(0,0,0,0.45)",
          rotate: 30,
        },
        axisLine: {
          lineStyle: {
            color: "rgba(0,0,0,0.45)",
          },
        },
        data: data.name,
      },
      yAxis: {
        name: "测评量",
        type: "value",
        axisLine: {
          show: true,
        },
      },
      series: [
        {
          type: "bar",
          data: data.data,
          barWidth: "40",
          itemStyle: {
            barBorderRadius: 20,
          },
        },
      ],
    };
  }
  private drawCeliangFenbu() {
    const d = this.cepingData.by_source_echart;
    this.cepingFenbu = {
      grid: {},
      tooltip: {},
      color: this.colors,
      series: [
        {
          type: "pie",
          data: d.data,
          radius: ["0%", "70%"],
        },
      ],
    };
  }
  private drawCeping() {
    const d = this.resultData;
    this.ceping = {
      grid: {},
      tooltip: {},
      color: this.colors,
      series: [
        {
          type: "pie",
          data: d.data,
          radius: ["0%", "70%"],
        },
      ],
    };
  }
  private drawAge() {
    const d = this.huiyuanData.age_distribution;
    this.ageOptions = {
      color: ["#77A4F1"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      grid: {
        top: 0,
        left: "60",
        right: "60",
        bottom: "20",
        containLabel: false,
      },
      xAxis: {
        show: false,
      },
      yAxis: {
        axisLine: {
          // y轴
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          // 网格线
          show: false,
        },
        type: "category",
        data: d.name,
      },
      series: [
        {
          name: "数量",
          type: "bar",
          data: d.data,
          label: {
            show: true,
            position: "right",
            color: "#333",
            formatter: (pa: any) => {
              return (pa.data.ratio * 100).toFixed(2) + "%";
            },
          },
          barWidth: "30",
          itemStyle: {
            barBorderRadius: 15,
          },
        },
      ],
    };
  }
  private drawHuiyuan() {
    const d = this.huiyuanData.source_distribution;
    const Chart: any = echarts.init(this.$refs.huiyuan as HTMLCanvasElement);
    this.huiyuanOption = {
      color: ["#75DDB5"],
      tooltip: {
        show: true,
        trigger: "item",
      },
      grid: {
        left: "80",
        right: "2%",
        top: "40",
        bottom: "100",
      },
      xAxis: {
        type: "category",
        axisLabel: {
          rotate: 45,
        },
        axisLine: {
          lineStyle: {
            color: "rgba(0,0,0,0.45)",
          },
        },
        data: d.name,
      },
      yAxis: {
        name: "会员数",
        type: "value",
        axisLine: {
          show: true,
        },
      },
      series: [
        {
          type: "bar",
          data: d.data,
          // itemStyle: {
          //   color: "#6C99F6",
          // },
          barWidth: "40",
          itemStyle: {
            barBorderRadius: 20,
          },
        },
      ],
    };
    Chart.setOption(this.huiyuanOption, true);
    Chart.off("click");
    Chart.on("click", (p: any) => {});
  }
  private handleChartClick(e: any) {}
  private getHuiyuanData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostStatisticsPatient(this, loading).then((res: any) => {
      this.huiyuanData = res.data;
      // 处理性别数据
      let sexData: any = {
        男: "",
        女: "",
      };
      const sexD = res.data.gender_distribution;
      sexD.name.forEach((name: any) => {
        const val: any = sexD.data.filter(
          (person: any) => person.name === name
        );
        sexData[name] = val[0].ratio;
      });
      this.huiyuanData.sexData = sexData;
      this.drawAge();
      this.drawHuiyuan();
    });
  }
  private getCepingData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      year: this.filters.cepingYear,
    };
    if (this.filters.cepingTime != "全部时间") {
      params.time = this.filters.cepingTime;
    }
    if (this.filters.cepingTime === "自定义") {
      params.time_interval = [
        this.filters.startTime || "",
        this.filters.endTime || "",
      ];
    }
    PostStatisticsCeping(this, params, loading).then((res: any) => {
      this.cepingData = res.data;
      this.drawCepingQushi();
      this.drawCeliangFenbu();
    });
  }
  private getTemData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      source_id: this.cSource.source_id,
    };
    PostStatisticsTem(this, params, loading).then((res: any) => {
      this.temData = res.data;
      if (this.temData.data && this.temData.data.length > 0) {
        this.cTem = this.temData.data[0];
        this.getResultData();
      }
    });
  }
  private getResultData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      template_id: this.cTem.template_id,
    };
    PostStatisticsResult(this, params, loading).then((res: any) => {
      this.resultData = res.data;
      this.drawCeping();
    });
  }
  private mounted() {
    this.getYears();
    this.getHuiyuanData();
    this.getCepingData();
    this.getTemData();
  }
}
